import { axios, getErrorMessage } from '../helpers/axioshelper'
import users from './users'
import scales from './scales'
import testmethods from './testmethods'
import instructions from './instructions'
import imagebank from './imagebank'
import testsuites from './testsuite'
import normgroups from './normgroups'
import expertreports from './expertreports'
import testdata from './testdata'

axios.interceptors.request.use(function(config) {
  if (typeof window === 'undefined') {
    return config
  }

  const token = window.sessionStorage.getItem('token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

axios.interceptors.response.use(
  function(response) {
    return response
  },
  function(error) {
    if (error.response.status === 401) {
      window.location = '/'
    }
    return Promise.reject(error)
  }
)

const appService = {
  users,
  scales,
  testmethods,
  instructions,
  imagebank,
  testsuites,
  normgroups,
  expertreports,
  testdata,
  getAppSettings() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/app/settings')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getLanguages() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/app/languages')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getCompanyLogo(urlTag) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/app/companylogo?urlTag=${urlTag}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  login(credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/auth/login', credentials)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  refreshToken() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/auth/token')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}

export default appService
